import { render, staticRenderFns } from "./SideColumn.vue?vue&type=template&id=49a05dd7&scoped=true"
import script from "./SideColumn.vue?vue&type=script&lang=js"
export * from "./SideColumn.vue?vue&type=script&lang=js"
import style0 from "./SideColumn.vue?vue&type=style&index=0&id=49a05dd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a05dd7",
  null
  
)

export default component.exports